import { includes } from 'es-toolkit/compat';

export const isDemoLab = (labId: string) =>
  includes(['cc66db90-1e3e-11e9-80b7-0af5642e5b64', '4855ea4a-76e5-11ed-9e69-07024b8ed84d'], labId);

export const isPfizerDemoLab = (labId: string) => 'ebe46ebe-ab8e-11e9-82bb-0a27be703864' === labId;
